import { useState, useEffect } from "react";

export default function useInsurersOptions() {
    const [insurersOptions] = useState([
        { value: "NA", label: "N/A" },
        { value: "LIMUT", label: "Liberty Mutual" },
        { value: "SF", label: "State Farm" },
        { value: "PROG", label: "Progressive" },
        { value: "ALLS", label: "Allstate" },
        { value: "TRAV", label: "Travelers" },
        { value: "CHUBB", label: "Chubb" },
        { value: "NW", label: "Nationwide" },
        { value: "HART", label: "The Hartford" },
        { value: "ERIE", label: "Erie" },
        { value: "ZUR", label: "Zurich" },
        { value: "AMFAM", label: "AmFam" },
        { value: "AOG", label: "Auto-Owners Group" },
        { value: "CAN", label: "CAN" },
        { value: "OTHER", label: "Other" },
        { value: "AIG", label: "AIG" }
    ]);

    return insurersOptions;
}
